/*eslint-disable */
import {
  mapGetters,
  mapState
} from 'vuex';
var $ = window.jQuery = jQuery = require('jquery');
import toast from '../../services/toast';

export default {
  name: 'mycourse',
  components: {},
  props: [],
  data() {
    return {
      mycourses: {},
      courseID: '',
      courseIndex: '',
      havenocourse: '',
      categoryList: {},
      showModal: false
    }
  },
  computed: {
    ...mapGetters([
      'erolledCourses',
      'getCategoryList',
      //'getProfileInfo'
    ]),
    // getUserSubscription() {
    //   this.$store.dispatch('getProfile').then((res) => {
    //     this.userSubscription = this.$store.getters.getProfileInfo.has_active_subscription
    //     if(!this.userSubscription){
    //       if(this.$route.path === '/favourites/'){
    //         this.$router.push('/payment/')
    //       }
    //     }
    //   }).catch((err) => {});
    // },
    getEnrolledCourses() {
      return this.mycourses = this.$store.getters.erolledCourses.results;
    },
  },
  mounted() {
    // this.getUserSubscription
    this.getEnrolledCourses
  },
  methods: {
    removeItem(id, index) {
      this.showModal = true;
      $('body').addClass('showoverlay');
      this.courseID = id;
      this.courseIndex = index;
    },
    removeConfirmation() {
      let data = {
        courseid: this.courseID
      }
      this.$store.dispatch('removeMyCourse', data)
        .then((res) => {
          if (res.status == '200' || res.status == '204') {
            this.$delete(this.mycourses, this.courseIndex)
            console.log(res.data)
            toast.success(res.data.msg || 'Course removed successfully');
            $('body').removeClass('showoverlay');
            this.showModal = false
            //  this.getEnrolledCourses;
          }
        })
        .catch((err) => {})
    },

    getCoursebyCategory(event) {

      if (event.target.value != "" && event.target.value != undefined) {
        this.$store.dispatch('CourseByCategoryAction', {
          id: event.target.value
        }).then((response) => {
          if (response.data.code == '2000') {
            this.mycourses = this.$store.state.userCourses.couseByCategoryList.courses

            return this.mycourses
          }
        })
      } else {

        this.$store.dispatch('getcourselist').then((res) => {

          return this.mycourses = this.$store.getters.erolledCourses.results;
        }).catch((err) => {});


      }
    },
    hideOverlay() {
      this.showModal = false;
      $('body').removeClass('showoverlay');
    }

  },
  created() {

  },
  watch: {
    getEnrolledCourses() {
      return this.$store.getters.erolledCourses
    },
  }
}